import { render } from "./UpdateTemplateIsoPermissions.vue?vue&type=template&id=2daffe78&scoped=true"
import script from "./UpdateTemplateIsoPermissions.vue?vue&type=script&lang=js"
export * from "./UpdateTemplateIsoPermissions.vue?vue&type=script&lang=js"

import "./UpdateTemplateIsoPermissions.vue?vue&type=style&index=0&id=2daffe78&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.22.0.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2daffe78"]])

export default __exports__